let configObj = {
    Host: "smtp.elasticemail.com",
    Username: "viral.gajera@analyticsvalley.com",
    Password: "A07474D3E55540B59CE4ECF30C3F53757F48",
    To: "viral.gajera218@gmail.com",
    From: "viral.gajera@analyticsvalley.com",
};

export default configObj;
